import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { Alert, Card, CardBody, CardTitle, Col, FormGroup, Label, Row } from "reactstrap"
import SplitOrOptimization from "./TTCampaignSettings/SplitOrOptimization"
import { AvField, AvInput } from "availity-reactstrap-validation"
import CustomSelect from "../../../../../components/Common/CustomSelect"
import { getDefaultValueForSelect } from "../../../../../helpers/utils"

export const IOS_DEDICATED_CAMPAIGN_KEY = "ios-dedicated-campaign"
const APP_FIELD_NAME = IOS_DEDICATED_CAMPAIGN_KEY + "_app"
const APP_OPTIMIZE_DELIVERY = "app-profile-page-to-optimize-delivery"


const options = [
  { label: "AUTODOC", value: "autodoc" },
  { label: "JOOM", value: "joom" },
  { label: "TEST", value: "test" }
]

const campaign_types = [
  { label: "App install", description: "Get new users to install your app.", value: "app_install" },
  {
    label: "App retargeting",
    description: "Re-engage existing users to take action in your app. App retargeting isn't supported for IOS 14.5+ devices.",
    value: "app_retargeting"
  }
]

const IOSDedicatedCampaign = ({ items, onChange, isFormSubmit }) => {
  const [isActive, setIsActive] = React.useState(false)
  const [app, setApp] = React.useState(null)
  const [campaignType, setCampaignType] = React.useState(campaign_types[0].value)

  React.useEffect(() => {
    setApp(null)
  }, [isActive])

  const hasItem = React.useMemo(() => items.some(i => i === IOS_DEDICATED_CAMPAIGN_KEY), [items])
  if (!hasItem) return <></>

  return (
    <>
      <Card>
        <CardBody>
          <CardTitle className="font-weight-semibold font-size-14 mb-4">Campaign type</CardTitle>
          <div>
            <Label htmlFor="">App promotion type</Label>
          </div>
          {campaign_types.map(i => (
            <div className="form-check" key={i.value}>
              <AvInput
                className="form-check-input"
                type="radio"
                name="campaign_type"
                checked={campaignType === i.value}
                onChange={e => setCampaignType(e.target.value)}
                id={i.value}
                value={i.value}
              />
              <label
                className="form-check-label"
                htmlFor={i.value}
                style={{ fontWeight: 400 }}
              >
                {i.label}
                <p className="text-muted mt-1 font-size-11">{i.description}</p>
              </label>
            </div>
          ))}
        </CardBody>
      </Card>
      {campaignType === "app_install" && <Card key={IOS_DEDICATED_CAMPAIGN_KEY + "key"}>
        <IOSDedicatedCampaignStyled>
          <CardTitle className="font-weight-semibold font-size-14 mb-4">IOS 14 dedicated campaign</CardTitle>
          <div
            className="form-check form-switch form-switch-md"
          >
            <input
              type="checkbox"
              className="form-check-input"
              id={IOS_DEDICATED_CAMPAIGN_KEY}
              checked={isActive}
              onChange={e => setIsActive(e.target.checked)}
            />
            <label
              className="form-check-label mb-4"
              htmlFor={IOS_DEDICATED_CAMPAIGN_KEY}
            >Use IOS 14 dedicated campaign</label>
          </div>
          {isActive ? <><Row>
            <Col md="6">
              <FormGroup className="mb-3">
                {/*<label*/}
                {/*  className="form-check-label mb-2"*/}
                {/*  htmlFor={APP_FIELD_NAME}*/}
                {/*>App</label>*/}
                <Label htmlFor="">App</Label>
                <CustomSelect
                  name={APP_FIELD_NAME}
                  options={options}
                  placeholder="Select app..."
                  classNamePrefix="select2-selection"
                  errorMessage="App field is required"
                  defaultValue={getDefaultValueForSelect(app)}
                  isLoading={false}
                  required
                  isFormSubmit={isFormSubmit}
                  onChange={(p, q) => setApp(p)}
                />
              </FormGroup>
            </Col>
            <Col md="6">
            </Col>
          </Row></> : <Alert color="primary" role="alert">
            <i className="mdi mdi-alert-circle-outline me-2"></i>
            {`Devices using IOS 14/5 or later IOS versions make up a large part of traffic. Turn on the toggle to ensure you're able to reach these users. If the toggle is off, your ads will not reach devices using IOS 14.5 or later IOS versions.`}
          </Alert>}
          {app && <>
            <Alert color="primary" role="alert">
              <i className="mdi mdi-alert-circle-outline me-2"></i>
              You can still create 1 IOS 14 dedicated campaigns for <b>{app.label}</b>
            </Alert>
            <div className="app-profile-page-to-optimize-delivery">
              <div className="form-check">
                <AvInput
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  name={APP_OPTIMIZE_DELIVERY}
                  id={APP_OPTIMIZE_DELIVERY}
                />
                <label
                  className="form-check-label"
                  htmlFor={APP_OPTIMIZE_DELIVERY}
                >
                  <span className="">Use app profile page to optimize delivery</span>
                  <p
                    className="text-muted mb-0 mt-1 font-size-11">{`A page displayed on Pangle ads when appropriate traffic is detected. This won't be seen on ads with a "in-app- event" or "Value" optimization goal.`}</p>
                </label>
              </div>
            </div>
          </>}
        </IOSDedicatedCampaignStyled>
      </Card>}
    </>
  )
}


IOSDedicatedCampaign.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  // data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  isFormSubmit: PropTypes.bool.isRequired
}

const IOSDedicatedCampaignStyled = styled(CardBody)`
  .app-profile-page-to-optimize-delivery {
    padding: 15px 25px;
    background-color: #f5f5f5;
    border-radius: 5px;
  }
`

export default (IOSDedicatedCampaign)
